import axios from 'axios';
/* istanbul ignore next */

export default async function loadRelevantId(url) {
  try {
    const response = await axios.get(url);
    const scriptElement = document.createElement('script');
    scriptElement.crossOrigin = 'anonymous';
    scriptElement.textContent = response.data;
    document.head.appendChild(scriptElement);
    return true;
  } catch (error) {
    console.error('Error loading Relevant ID:', error);
    return false;
  }
}
